import { isSolutionMonoTour, isSolutionStored } from './MemoryHelpers';

export const getInitialStep = (solution) => {
  if (isSolutionStored(solution)) return isSolutionMonoTour(solution) ? 4 : 3;
  return 1;
};
